import { render, staticRenderFns } from "./ObjectVacancy.vue?vue&type=template&id=506b47ba&scoped=true"
import script from "./ObjectVacancy.vue?vue&type=script&lang=js"
export * from "./ObjectVacancy.vue?vue&type=script&lang=js"
import style0 from "./ObjectVacancy.vue?vue&type=style&index=0&id=506b47ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b47ba",
  null
  
)

export default component.exports